import React, { useState, useEffect, useMemo } from 'react'
import useIsInViewport from 'use-is-in-viewport'

import Container from '../../../utils/Container'
import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import Button from '../../../elements/buttons/Button'
import ProgressiveImg from '../../../elements/images/ProgressiveImg'
import Loader from '../../../utils/Loader'
import typing from '../../../../medias/images/Typing-bro.png'


//CONATANTS
const maxD = 20
const maxW = 15000
const maxS = 1
const maxR = 6

const Statistics = () => {

	const [numberDocuments, setNumberDocuments] = useState(0)
	const [numberWord, setNumberWord] = useState(0)
	const [numberSites, setNumberSite] = useState(0)
	const [numberRevision, setNumberRevision] = useState(0)
	// const [interValId, setIntervalId] = useState(null)

	const [isInViewport, targetRef] = useIsInViewport()

	// useEffect(() => {
	// 	if(isInViewport){
	// 		incrementNumberOnScroll(maxD, maxW, maxS, maxR)
	// 	}
	// }, [isInViewport, numberDocuments, numberWord])



	useEffect(() => {
		if(isInViewport){
			if(numberDocuments < maxD){
				let interValId =setInterval(() => {
					setNumberDocuments(prevState => prevState + 1)
					clearInterval(interValId)
				}, 100)
			}
		}
	}, [isInViewport, numberDocuments])

	useEffect(() => {
		if(isInViewport){
			
			if(numberWord < maxW){
				let interValId = setInterval(() =>{
					setNumberWord(prevState => prevState + 1000)
					clearInterval(interValId)
				} , 80)
			}
		}
	}, [isInViewport, numberWord])

	useEffect(() => {
		if(isInViewport){
			
			if(numberSites < maxS){
				let interValId = setInterval(() =>{
					setNumberSite(prevState => prevState + 1)
					clearInterval(interValId)
				} , 300)
			}
		}
	}, [isInViewport, numberSites])

	useEffect(() => {
		if(isInViewport){
			
			if(numberRevision < maxR){
				let interValId = setInterval(() =>{
					setNumberRevision(prevState => prevState + 1)
					clearInterval(interValId)
				} , 100)
			}
		}
	}, [isInViewport, numberRevision])

	

	/*This function increment all number statistics*/
	
	function incrementNumberOnScroll(maxnumberD, maxnumberW, maxnumberS, maxnumberR){

		let intervalId = setInterval(() => {
			if(numberDocuments < maxnumberD){
				setNumberDocuments(prevState => prevState + 1)
			}

			if(numberWord < maxnumberW){
				setNumberWord(prevState => prevState + 200)
			}

			if(numberSites < maxnumberS){
				setNumberSite(prevState => prevState + 1)
			}

			if(numberRevision < maxnumberR){
				setNumberRevision(prevState => prevState + 1)
			}

			clearInterval(intervalId)
		}, 100)
	}


	return (
		<section
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv" } mt-32 md:mt-44`}
		>
            <Container classe="px-3 flex flex-col items-center">
				<Heading2 size='big' classe="text-center">Mes Réalisations</Heading2>
				<Paragraph classe="text-center w-auto md:w-115 mt-6 mb-15">
					N'hésitez pas à vérifier tous mes réseaux sociaux pour vous assurer qu'en plus d'être professionnelle, je suis aussi fiable et qu'il est facile de travailler avec moi.
				</Paragraph>
			</Container>

			<Container classe="px-3 grid gap-10 grid-cols-2 md:grid-cols-4 mt-10">
				<NumberIncrement chiffre={`+${numberDocuments}`} text="documents traduits" />
				<NumberIncrement chiffre={`0${numberRevision}`} text="documents corrigés et revisés" />
				<NumberIncrement chiffre={`0${numberSites}`} text="sites traduits" />
				<NumberIncrement chiffre={`+${numberWord}`} text="Milles mots traités" />
			</Container>
		</section>
	)
}


const NumberIncrement = ({ chiffre, text }) => {

	return(
		<div className="flex flex-col items-center">
			<span className="font-primary text-secondary font-xs block text-4xl md:text-6xl lg:text-7xl">{chiffre}</span>
			<span className="font-secondary text-sm md:text-base text-secondary text-center uppercase">{text}</span>
		</div>
	)
}

export default Statistics